"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fuel = function Fuel() {
  return _react2.default.createElement(
    "g",
    { id: "fuel" },
    _react2.default.createElement("path", {
      d: "M455.4,117.5 L455.7,117.2 L354.2,13.9 L325.3,43.3 L382.9,101.9 C357.2,111.9 339,136.9 339,166.6 C339,204.9 369.6,236 407.2,236 C417,236 426,233.8 434.5,230.2 L434.5,430.5 C434.5,445.8 422.2,458.3 407.2,458.3 C392.2,458.3 379.9,445.8 379.9,430.5 L379.9,305.5 C379.9,274.9 355.3,249.9 325.3,249.9 L298,249.9 L298,55.6 C298,25 273.4,0 243.4,0 L79.6,0 C49.6,0 25,25 25,55.6 L25,500 L298,500 L298,291.7 L338.9,291.7 L338.9,430.6 C338.9,468.9 369.5,500 407.1,500 C444.7,500 475.3,468.9 475.3,430.6 L475.3,166.7 C475.4,147.5 467.7,130 455.4,117.5 L455.4,117.5 Z M79.6,55.6 L243.4,55.6 L243.4,194.5 L79.6,194.5 L79.6,55.6 Z M407.1,194.4 C392.1,194.4 379.8,181.9 379.8,166.6 C379.8,151.3 392.1,138.8 407.1,138.8 C422.1,138.8 434.4,151.3 434.4,166.6 C434.4,181.9 422.1,194.4 407.1,194.4 L407.1,194.4 Z",
      id: "shape"
    })
  );
};

exports.default = Fuel;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Fuel.js
// module id = 2957
// module chunks = 4